import Client from 'localmed-api/lib/BaseClient';

export default new Client({
  host: '',
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
});
